import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-item-thumb-three',
  templateUrl: './item-thumb-three.component.html',
  styleUrls: ['./item-thumb-three.component.scss'],
})
export class ItemThumbThreeComponent implements OnInit {
  @Input() itemData: any;
  @Input() item: any;
  @Input() style: any;
  @Input() listType: string;
  description:any;
  constructor() { }

  ngOnInit() {
    let itemdescription = 'description' in this.item ? this.item.description : '';
    this.description = itemdescription.replace(/<[^>]*>/g, '');
  }

}
